import { render, staticRenderFns } from "./exchangeActive.vue?vue&type=template&id=3f74df3a&scoped=true&"
import script from "./exchangeActive.vue?vue&type=script&lang=js&"
export * from "./exchangeActive.vue?vue&type=script&lang=js&"
import style0 from "./exchangeActive.vue?vue&type=style&index=0&id=3f74df3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f74df3a",
  null
  
)

export default component.exports